import styled from 'styled-components'

const MainPage = styled.div`
  margin: 4px;
  flex: 1 1;
  display: flex;
  flex-direction: column;

  & > div {
    flex: 1 1;
  }
`
export default {
  MainPage,
}
